<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading">
        <v-container class="py-4 py-md-6">
          <div class="item">
            <div
              class="
                flex-column flex-sm-row
                d-flex
                align-center
                justify-space-between
              "
            >
              <div>
                <div
                  class="
                    d-flex
                    grey--text
                    text--darken-3 text-h6 text-md-h5 text-uppercase
                    font-weight-bold
                    mr-sm-8
                  "
                  v-if="item.title"
                >
                  {{ item.title }}
                </div>
              </div>

              <div class="d-flex mt-4 mt-sm-0">
                <ShareButtonsWidget />
              </div>
            </div>

            <div class="item-grid-list">
              <div class="white pb-4 mt-5 item-images">
                <PropertyImagesWidget
                  :images="item.images"
                  :reference="item.reference"
                />
                <div v-if="item.text && !mdAndDown" class="px-4">
                  <div class="my-4 separator"></div>

                  <div
                    class="
                      secondary--text
                      text-subtitle-1 text-md-h6 text-uppercase
                      font-weight-medium
                    "
                  >
                    Descrição
                  </div>

                  <div
                    class="grey--text text--darken-1 text-body-1 mt-2"
                    v-html="item.text"
                  ></div>
                </div>
              </div>

              <div class="item-description white mt-5 pa-3 pa-md-5">
                <div v-if="item.price">
                  <div class="secondary--text text-body-1">
                    {{ priceText }}
                  </div>

                  <div
                    class="
                      primary--text
                      text--darken-1 text-h5 text-md-h4
                      font-weight-medium
                    "
                  >
                    {{ item.price }}
                  </div>
                </div>

                <div class="mt-3 item-details" v-if="item.details.length">
                  <div v-for="(detail, i) in item.details" :key="i">
                    <div class="d-flex align-center py-1" v-if="detail.text">
                      <div class="item-details-simbol">
                        <v-icon
                          v-if="detail.icon"
                          color="secondary darken-2"
                          size="14px"
                        >
                          {{ detail.icon }}
                        </v-icon>

                        <div v-else-if="detail.img">
                          <img class="d-block" :src="detail.img" width="14px" />
                        </div>
                      </div>

                      <div
                        class="
                          secondary--text
                          text--darken-2 text-body-2
                          font-weight-medium
                          ml-1
                        "
                      >
                        {{ detail.text }}
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="item.characteristics.length">
                  <div class="my-4 separator"></div>

                  <div
                    class="
                      secondary--text
                      text-h6 text-md-h5 text-uppercase
                      font-weight-medium
                    "
                  >
                    Características
                  </div>

                  <div class="mt-2 item-details">
                    <template
                      v-for="(characteristic, i) in item.characteristics"
                    >
                      <div
                        :key="i"
                        class="d-flex align-center py-1"
                        v-if="characteristic"
                      >
                        <div class="item-details-simbol">
                          <v-icon color="primary" size="14px">
                            fa-chevron-right
                          </v-icon>
                        </div>

                        <div
                          class="
                            secondary--text
                            text--lighten-1 text-body-2
                            ml-1
                          "
                        >
                          {{ characteristic }}
                        </div>
                      </div>
                    </template>
                  </div>
                </div>

                <div v-if="informations.whatsapp_float">
                  <div class="my-4 separator"></div>

                  <div
                    class="
                      secondary--text
                      text-h6 text-md-h5 text-center text-uppercase
                      font-weight-medium
                    "
                  >
                    Dúvidas sobre o imóvel?
                  </div>

                  <div
                    class="
                      grey--text
                      text--darken-1 text-body-1 text-center
                      font-weight-regular
                      mt-1
                    "
                  >
                    Entre em contato com a gente no WhatsApp para mais
                    informações.
                  </div>

                  <div class="mt-5 mb-n3 mb-md-n5 mx-n3 mx-md-n5">
                    <v-btn
                      class="white--text text-subtitle-2 text-md-h6"
                      color="primary"
                      :href="
                        informations.whatsapp_float +
                        '?text=Olá, tenho interesse no imóvel ' +
                        files +
                        $route.path
                      "
                      target="_blank"
                      :height="mobile ? '42px' : '54px'"
                      depressed
                      block
                      tile
                    >
                      <v-icon color="white" :size="mobile ? 20 : 24" left>
                        fa-whatsapp
                      </v-icon>
                      ENTRE EM CONTATO
                    </v-btn>
                  </div>
                </div>
              </div>

              <div
                v-if="item.text && mdAndDown"
                class="white mt-5 pa-3 pa-md-5 px-4"
              >
                <div
                  class="
                    secondary--text
                    text-subtitle-1 text-md-h6 text-uppercase
                    font-weight-medium
                  "
                >
                  Descrição
                </div>

                <div
                  class="grey--text text--darken-1 text-body-1 mt-2"
                  v-html="item.text"
                ></div>
              </div>
            </div>
          </div>
        </v-container>

        <RelatedPropertiesSection
          v-if="districtId"
          :id="itemId"
          :district="districtId"
          v-bind="$props"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import ShareButtonsWidget from "../components/widgets/ShareButtonsWidget.vue";
import PropertyImagesWidget from "../components/widgets/PropertyImagesWidget.vue";
import RelatedPropertiesSection from "../components/sections/RelatedPropertiesSection.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  mod: "properties",
};

export default {
  props: {
    business: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    item: {},
    districtId: null,
  }),
  created() {
    this.getItem();
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    priceText() {
      return this.business === 1 ? "Casa para alugar por" : "Casa a venda por";
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getItem() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          const images = [];
          this.item.images = data.images.map(({ url }) => {
            images.push(url);
          });

          this.item.images = images;

          const details = [];
          if (parseFloat(data.total_area) > 0)
            details.push({
              icon: "fa-expand-arrows-alt",
              text: `${data.total_area} Área total`,
            });

          if (parseFloat(data.area) > 0)
            details.push({
              icon: "fa-home",
              text: `${data.area} Área construída`,
            });

          if (Number(data.bedrooms) > 0 || Number(data.suites) > 0) {
            let text = "";
            if (Number(data.bedrooms) > 0) {
              text += `${data.bedrooms} Dormitório(s)`;

              if (Number(data.suites) > 0) text += ` | ${data.suites} Suíte(s)`;
            } else if (Number(data.suites) > 0) {
              text += `${data.suites} Suíte(s)`;
            }

            details.push({
              icon: "fas fa-bed",
              text: text,
            });
          }

          if (Number(data.living_room) > 0)
            details.push({
              icon: "fas fa-couch",
              text:
                Number(data.living_room) > 1
                  ? `${data.living_room} Salas de estar`
                  : `${data.living_room} Sala de estar`,
            });

          if (Number(data.bathrooms) > 0)
            details.push({
              icon: "fas fa-bath",
              text: `${data.bathrooms} Banheiro(s) social(is)`,
            });

          if (Number(data.garage) > 0)
            details.push({
              icon: "fas fa-car",
              text:
                Number(data.garage) > 1
                  ? `${data.garage} Vagas de garagem`
                  : `${data.garage} Vaga de garagem`,
            });

          this.item.details = details;

          const characteristics = [];

          if (data.grill) characteristics.push("Churrasqueira");
          if (data.gourmet_space) characteristics.push("Espaço Gourmet");
          if (data.pool) characteristics.push("Piscina");
          if (data.pandry) characteristics.push("Despensa");
          if (data.laundry) characteristics.push("Lavanderia");
          if (data.toilet) characteristics.push("Lavabo");

          this.item.characteristics = characteristics;
        })
        .catch(() => this.$router.push("/erro404"))
        .then(() => (this.loading = false));
    },
    formatToURL,
  },
  watch: {
    itemId() {
      this.getItem();
    },
    item() {
      document.title = `${this.item.title} | ${this.informations.name}`;

      this.$rest("propertiesDistricts")
        .get()
        .then((item) => {
          this.districtId = item.find(
            ({ title, city, state }) =>
              `${formatToURL(title)}-${formatToURL(city)}-${formatToURL(
                state
              )}` ===
              `${formatToURL(this.item.district)}-${formatToURL(
                this.item.city
              )}-${formatToURL(this.item.state)}`
          ).id;
        });
    },
  },
  components: {
    LoadingWidget,
    ShareButtonsWidget,
    PropertyImagesWidget,
    RelatedPropertiesSection,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-grid-list {
    display: grid;
    gap: 0 10px;
    grid-template-columns: 700px auto;

    @media screen and (max-width: 1264px) {
      grid-template-columns: 100%;
    }
  }

  &-images,
  &-description {
    height: min-content;
  }

  &-details {
    display: grid;
    gap: 4px 10px;
    grid-template-columns: minmax(0, 60%) auto;

    &-simbol {
      width: 20px;
      display: flex;
      justify-content: center;
    }
  }
}

.separator {
  background-color: #f2f3f3;
  height: 1px;
  width: 100%;
}
</style>
